import { api } from "../../gateways/unilabApi";

export async function getMaterialsList() {
  return await api.get(`material/listfull`);
}
export async function getMaterialsListFiltered(payload) {
  return await api.get(`material/listFiltered?tags=` + payload);
}
export async function getMaterialsListFilteredOrdered(payload) {
  return await api.get(`material/listFilteredAndOrdered?tags=` + payload);
}
export async function postRemove(payload) {
  return await api.post(`material/destroy`, payload);
}
export async function getMaterialsExportList() {
  return await api.get(`material/listfullExport`);
}
export async function postUpdateAddAllExport(payload) {
  return await api.post(`material/updateAddAllExport`, payload);
}
export async function getExportModel() {
  return await api.get(`material/exportModel`);
}
